export const wait = (millisecond: number) => {
  return new Promise(resolve => setTimeout(resolve, millisecond));
};
